import React, {PureComponent} from 'react';
import Hammer from 'react-hammerjs';
import * as ReactGA from '../../GA';
import {ROUTES} from '../../routes';
import TranslatedText from '../../atoms/TranslatedText';
import animatedCircles from '../../assets/animated-circles.png';
import Apng from '../../atoms/Apng';

import './SingleLayer.css';

const SECTIONS = {
    oakley: {
        title: 'hdpolarized.single_layer.oakley.title',
        subtitle: 'hdpolarized.single_layer.oakley.subtitle',
        label: 'hdpolarized.single_layer.oakley.label',
        beam: require('./SingleLayer-beam-oakley.png'),
        lens: require('./oakley-lens.png'),
    },
    competitor: {
        title: 'hdpolarized.single_layer.competitor.title',
        subtitle: 'hdpolarized.single_layer.competitor.subtitle',
        label: 'hdpolarized.single_layer.competitor.label',
        beam: require('./SingleLayer-beam-competitor.png'),
        lens: require('./competitor-lens.png'),
        lensLabel: 'hdpolarized.single_layer.competitor.lens_label',
        glueLabel: 'hdpolarized.single_layer.competitor.glue_label',
        filterLabel: 'hdpolarized.single_layer.competitor.filter_label',
    },
};

export default class SingleLayer extends PureComponent {
    state = {type: this.props.match.params.type, state: null};

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.type !== state.type) {
            return {type: props.match.params.type, state: null};
        }

        return null;
    }

    componentDidMount() {
        ReactGA.pageview('HD Polarized - Single Layer');
    }

    onSwipe = event => {
        if (event.direction === 4) {
            this.props.history.push(ROUTES.HDPOLARIZED_SINGLELAYER_OAKLEY);
        }

        if (event.direction === 2) {
            this.props.history.push(ROUTES.HDPOLARIZED_SINGLELAYER_COMPETITOR);
        }
    };

    render() {
        const type = this.props.match.params.type;
        const currentType = SECTIONS[type];
        const centerContentClasses = 'center-content ' + type;

        const bullets = Object.keys(SECTIONS).map(singleSection => (
            <div
                key={singleSection}
                className={
                    this.state.type === singleSection
                        ? 'bullet bullet--active'
                        : 'bullet'
                }
            />
        ));

        return (
            <article className="SingleLayer--bg">
                <Hammer onSwipe={this.onSwipe}>
                    <div className="SingleLayer-container">
                        <h3 className="top-title">
                            <TranslatedText tag={currentType.title} />
                        </h3>
                        <h4>
                            <TranslatedText tag={currentType.subtitle} />
                        </h4>
                        <div className="Single-layer-info">
                            <Apng
                                src={animatedCircles}
                                alt=""
                                draggable="false"
                            />
                            <p>
                                <TranslatedText tag={currentType.label} />
                            </p>
                        </div>

                        <div className="SingleLayer-swipe-indicator">
                            <div className="bullets">{bullets}</div>
                        </div>

                        <div className="SingleLayer-action-label">
                            <TranslatedText tag="hdpolarized.single_layer.swipe" />
                        </div>

                        <div className={centerContentClasses}>
                            <Apng
                                className="SingleLayer-light SingleLayer-light--oakley"
                                src={SECTIONS['oakley'].beam}
                                draggable="false"
                                alt=""
                            />
                            <Apng
                                className="SingleLayer-light SingleLayer-light--competitor"
                                src={SECTIONS['competitor'].beam}
                                draggable="false"
                                alt=""
                            />
                        </div>
                        <div className={centerContentClasses}>
                            <div className="SingleLayer-lens-container">
                                <img
                                    src={currentType.lens}
                                    alt=""
                                    draggable="false"
                                    className="SingleLayer-lens-img"
                                />
                                <div
                                    className={
                                        this.state.type === 'competitor'
                                            ? 'SingleLayer-lens-labels SingleLayer-lens-labels--active'
                                            : 'SingleLayer-lens-labels'
                                    }>
                                    <div className="SingleLayer-lens-label">
                                        <TranslatedText
                                            tag={currentType.lensLabel}
                                        />
                                    </div>
                                    <div className="SingleLayer-lens-label">
                                        <TranslatedText
                                            tag={currentType.glueLabel}
                                        />
                                    </div>
                                    <div className="SingleLayer-lens-label">
                                        <TranslatedText
                                            tag={currentType.filterLabel}
                                        />
                                    </div>
                                    <div className="SingleLayer-lens-label">
                                        <TranslatedText
                                            tag={currentType.glueLabel}
                                        />
                                    </div>
                                    <div className="SingleLayer-lens-label">
                                        <TranslatedText
                                            tag={currentType.lensLabel}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Hammer>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/hdpolarized/SingleLayer.js